module.exports = __webpack_public_path__ + "static/media/industry-alt.e4c84427.svg";